import getCollection from './getCollection'
import { getDoc } from 'firebase/firestore/lite'

const getSettings = async () => getDoc(getCollection()).then((d) => d.data())

export default getSettings
